// import React, { useEffect, useState } from "react";
// import { MapContainer, TileLayer, LayersControl, GeoJSON, useMap } from "react-leaflet";
// import "leaflet/dist/leaflet.css";
// import { FaPlay, FaPause, FaAngleLeft, FaAngleDoubleLeft, FaAngleRight, FaAngleDoubleRight } from "react-icons/fa";
// import { FaCircleInfo } from "react-icons/fa6";

// const INITIAL_VIEW_STATE = {
//   longitude: 125.7275,
//   latitude: -9.1747,
// };

// // Generate timestamps for 3 days at 3-hour intervals starting from 13 May 2025 00:00 UTC
// // const START_DATE = new Date("2025-05-13T00:00:00Z");
// // const END_DATE = new Date("2025-05-16T00:00:00Z");
// const START_DATE = new Date();
// START_DATE.setUTCHours(0, 0, 0, 0); // Set to midnight UTC of current date

// const END_DATE = new Date(START_DATE);
// END_DATE.setUTCDate(START_DATE.getUTCDate() + 3); // Add 3 days
// const INTERVAL_HOURS = 3;
// const timestamps = [];
// for (let time = START_DATE.getTime(); time <= END_DATE.getTime(); time += INTERVAL_HOURS * 60 * 60 * 1000) {
//   timestamps.push(new Date(time));
// }

// // Component to add GeoJSON layers
// const BoundaryLayer = ({ url, layerName }) => {
//   const map = useMap();
//   const [geoJsonData, setGeoJsonData] = useState(null);

//   useEffect(() => {
//     const fetchGeoJson = async () => {
//       try {
//         const response = await fetch(url);
//         if (!response.ok) throw new Error(`Failed to fetch GeoJSON for ${layerName}`);
//         const data = await response.json();
//         setGeoJsonData(data);
//       } catch (error) {
//         console.error(`Error loading GeoJSON for ${layerName}:`, error);
//       }
//     };

//     fetchGeoJson();
//   }, [url, layerName]);

//   if (!geoJsonData) return null;

//   return (
//     <GeoJSON
//       data={geoJsonData}
//       style={() => ({
//         color: "black",
//         weight: 1,
//         fillOpacity: 0, // Transparent fill
//       })}
//       onEachFeature={(feature, layer) => {
//         if (feature.properties && feature.properties.name) {
//           layer.bindPopup(feature.properties.name);
//         }
//       }}
//     />
//   );
// };

// // Info button component
// const InfoButton = ({ setInfo }) => {
//   useMap();
//   return (
//     <div
//       style={{
//         position: "absolute",
//         bottom: "60px",
//         left: "10px",
//         padding: "8px",
//         borderRadius: "5px",
//         fontSize: "15px",
//         cursor: "pointer",
//         zIndex: 999,
//       }}
//       onMouseEnter={() => setInfo(true)}
//       onMouseLeave={() => setInfo(false)}
//     >
//       <FaCircleInfo />
//     </div>
//   );
// };

// // Main Forecast Component
// const Fireforecast = () => {
//   const [info, setInfo] = useState(false);
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [isPlaying, setIsPlaying] = useState(false);

//   // Auto-play functionality
//   useEffect(() => {
//     let interval;
//     if (isPlaying) {
//       interval = setInterval(() => {
//         setCurrentIndex((prev) => (prev + 1) % timestamps.length);
//       }, 2000); // 2 seconds per frame
//     }
//     return () => clearInterval(interval);
//   }, [isPlaying]);

//   const handlePlayPause = () => setIsPlaying(!isPlaying);
//   const handleSliderChange = (e) => {
//     setCurrentIndex(Number(e.target.value));
//     setIsPlaying(false);
//   };
//   const handlePrevStep = () => {
//     setCurrentIndex((prev) => (prev - 1 < 0 ? timestamps.length - 1 : prev - 1));
//     setIsPlaying(false);
//   };
//   const handleNextStep = () => {
//     setCurrentIndex((prev) => (prev + 1 >= timestamps.length ? 0 : prev + 1));
//     setIsPlaying(false);
//   };
//   const handleFirst = () => {
//     setCurrentIndex(0);
//     setIsPlaying(false);
//   };
//   const handleLast = () => {
//     setCurrentIndex(timestamps.length - 1);
//     setIsPlaying(false);
//   };

//   const currentTimestamp = timestamps[currentIndex];
//   const formattedDate = currentTimestamp
//     .toISOString()
//     .replace("T", " ")
//     .substring(8, 16)
//     .replace(" ", " MAY ")
//     .toUpperCase() + " UTC";

//   return (
//     <div className="relative">
//       <MapContainer
//         center={[INITIAL_VIEW_STATE.latitude, INITIAL_VIEW_STATE.longitude]}
//         zoom={8}
//         style={{ width: "100%", height: "82.7vh" }}
//       >
//         <LayersControl position="topright">
//           <TileLayer
//             url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//             attribution='© <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
//           />
//           <LayersControl.BaseLayer checked name="OpenStreetMap" />

//           {/* Boundary Layers */}
//           <LayersControl.Overlay checked name="country">
//             <BoundaryLayer
//               url="/DATA/OSMbased_adm0_boundary.json"
//               layerName="country"
//             />
//           </LayersControl.Overlay>
//           <LayersControl.Overlay name="Municipality">
//             <BoundaryLayer
//               url="/DATA/OSMbased_adm1_boundary.json"
//               layerName="municipality"
//             />
//           </LayersControl.Overlay>
//           <LayersControl.Overlay name="Post Admin">
//             <BoundaryLayer
//               url="/DATA/OSMbased_adm2_boundary.json"
//               layerName="submunicipality"
//             />
//           </LayersControl.Overlay>
//           <LayersControl.Overlay name="Suco">
//             <BoundaryLayer
//               url="/DATA/OSMbased_adm3_boundary.json"
//               layerName="suco"
//             />
//           </LayersControl.Overlay>
//         </LayersControl>

//         {info && (
//           <div
//             style={{
//               position: "absolute",
//               bottom: "62px",
//               left: "35px",
//               fontSize: "12px",
//               zIndex: 1000,
//               backgroundColor: "white",
//               padding: "5px",
//               borderRadius: "5px",
//               boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
//             }}
//           >
//             x-day temperature forecast at x hour intervals.
//           </div>
//         )}
//         <InfoButton setInfo={setInfo} />

//         {/* Bottom Control Bar */}
//         <div
//           style={{
//             position: "absolute",
//             bottom: "0",
//             left: "0",
//             width: "100%",
//             background: "white",
//             color: "black",
//             display: "flex",
//             alignItems: "center",
//             padding: "5px",
//             zIndex: 1000,
//             fontFamily: "Arial, sans-serif",
//             fontSize: "14px",
//           }}
//         >
//           {/* Play/Pause Button */}
//           <button
//             onClick={handlePlayPause}
//             style={{
//               backgroundColor: "#1E90FF",
//               border: "none",
//               borderRadius: "50%",
//               width: "30px",
//               height: "30px",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               marginRight: "10px",
//               cursor: "pointer",
//             }}
//           >
//             {isPlaying ? <FaPause size={14} color="white" /> : <FaPlay size={14} color="white" />}
//           </button>

//           {/* Navigation Arrows */}
//           <button
//             onClick={handleFirst}
//             style={{
//               backgroundColor: "transparent",
//               border: "1px solid #666",
//               borderRadius: "4px",
//               padding: "5px",
//               marginRight: "5px",
//               cursor: "pointer",
//             }}
//           >
//             <FaAngleDoubleLeft size={14} color="black" />
//           </button>
//           <button
//             onClick={handlePrevStep}
//             style={{
//               backgroundColor: "transparent",
//               border: "1px solid #666",
//               borderRadius: "4px",
//               padding: "5px",
//               marginRight: "10px",
//               cursor: "pointer",
//             }}
//           >
//             <FaAngleLeft size={14} color="black" />
//           </button>

//           {/* Timestamp Display */}
//           <span
//             style={{
//               marginRight: "10px",
//               backgroundColor: "white",
//               padding: "2px 5px",
//             }}
//           >
//             {formattedDate}
//           </span>

//           {/* Navigation Arrows (Right) */}
//           <button
//             onClick={handleNextStep}
//             style={{
//               backgroundColor: "transparent",
//               border: "1px solid #666",
//               borderRadius: "4px",
//               padding: "5px",
//               marginRight: "5px",
//               cursor: "pointer",
//             }}
//           >
//             <FaAngleRight size={14} color="black" />
//           </button>
//           <button
//             onClick={handleLast}
//             style={{
//               backgroundColor: "transparent",
//               border: "1px solid #666",
//               borderRadius: "4px",
//               padding: "5px",
//               marginRight: "10px",
//               cursor: "pointer",
//             }}
//           >
//             <FaAngleDoubleRight size={14} color="black" />
//           </button>

//           {/* Slider */}
//           <div style={{ flex: 1, position: "relative" }}>
//             <input
//               type="range"
//               min="0"
//               max={timestamps.length - 1}
//               value={currentIndex}
//               onChange={handleSliderChange}
//               style={{
//                 width: "100%",
//                 background: `linear-gradient(to right, #1E90FF 0%, #1E90FF ${
//                   (currentIndex / (timestamps.length - 1)) * 100
//                 }%, #4A5A6A ${(currentIndex / (timestamps.length - 1)) * 100}%, #4A5A6A 100%)`,
//                 height: "8px",
//                 borderRadius: "4px",
//                 appearance: "none",
//                 outline: "none",
//                 cursor: "pointer",
//               }}
//             />
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 fontSize: "12px",
//                 marginTop: "5px",
//                 color: "black",
//               }}
//             >
//               <span>{START_DATE.toISOString().substring(8, 10)} MAY 00:00 UTC</span>
//               <span>{END_DATE.toISOString().substring(8, 10)} MAY 00:00 UTC</span>
//             </div>
//           </div>

//           {/* Gradient Legend */}
//           <div
//             style={{
//               width: "20%",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               padding: "0 10px",
//             }}
//           >
//             <div
//               style={{
//                 width: "100%",
//                 height: "10px",
//                 background: "linear-gradient(to right, rgb(4, 255, 0), #FFFF00, #FFA500, #FF0000)",
//                 marginRight: "10px",
//               }}
//             />
//           </div>
//         </div>
//       </MapContainer>
//     </div>
//   );
// };

// export default Fireforecast;


import React, { useEffect, useState, useRef, useCallback } from "react";
import { MapContainer, TileLayer, LayersControl, GeoJSON, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { FaPlay, FaPause, FaAngleLeft, FaAngleDoubleLeft, FaAngleRight, FaAngleDoubleRight } from "react-icons/fa";
import { FaCircleInfo } from "react-icons/fa6";
import { MapHomeControl } from "../../../common/MapControls/MapControls";

const INITIAL_VIEW_STATE = {
  longitude: 125.7275,
  latitude: -9.1747,
};

// Generate timestamps for 3 days at 3-hour intervals starting from current date
const START_DATE = new Date();
START_DATE.setUTCHours(0, 0, 0, 0); // Set to midnight UTC of current date

const END_DATE = new Date(START_DATE);
END_DATE.setUTCDate(START_DATE.getUTCDate() + 3); // Add 3 days
const INTERVAL_HOURS = 3;
const timestamps = [];
for (let time = START_DATE.getTime(); time <= END_DATE.getTime(); time += INTERVAL_HOURS * 60 * 60 * 1000) {
  timestamps.push(new Date(time));
}

// Component to add GeoJSON layers
const BoundaryLayer = ({ url, layerName }) => {
  const [geoJsonData, setGeoJsonData] = useState(null);

  useEffect(() => {
    const fetchGeoJson = async () => {
      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Failed to fetch GeoJSON for ${layerName}`);
        const data = await response.json();
        setGeoJsonData(data);
      } catch (error) {
        console.error(`Error loading GeoJSON for ${layerName}:`, error);
      }
    };

    fetchGeoJson();
  }, [url, layerName]);

  if (!geoJsonData) return null;

  return (
    <GeoJSON
      data={geoJsonData}
      style={() => ({
        color: "black",
        weight: 1,
        fillOpacity: 0, // Transparent fill
      })}
      onEachFeature={(feature, layer) => {
        if (feature.properties && feature.properties.name) {
          layer.bindPopup(feature.properties.name);
        }
      }}
    />
  );
};

// Info button component
const InfoButton = ({ setInfo }) => {
  useMap();
  // Leaflet's own drag/click handling swallows clicks on overlay controls
  // unless propagation to the map is explicitly disabled on the DOM node.
  const btnRef = useCallback((node) => {
    if (node) {
      L.DomEvent.disableClickPropagation(node);
      L.DomEvent.disableScrollPropagation(node);
    }
  }, []);
  return (
    <div
      ref={btnRef}
      style={{
        position: "absolute",
        bottom: "20px",
        left: "12px",
        padding: "8px",
        borderRadius: "8px",
        fontSize: "15px",
        cursor: "pointer",
        background: "rgba(255, 255, 255, 0.9)",
        backdropFilter: "blur(10px) brightness(1.1)",
        WebkitBackdropFilter: "blur(10px) brightness(1.1)",
        border: "1px solid rgba(0, 0, 0, 0.08)",
        color: "#333333",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
        transition: "all 0.2s ease",
        zIndex: 1000,
      }}
      onMouseEnter={() => setInfo(true)}
      onMouseLeave={() => setInfo(false)}
    >
      <FaCircleInfo />
    </div>
  );
};

// Main Forecast Component
const Fireforecast = () => {
  const [info, setInfo] = useState(false);
  const infoRef = useRef(null);
  const infoPanelRef = useCallback((node) => {
    infoRef.current = node;
    if (node) {
      L.DomEvent.disableClickPropagation(node);
      L.DomEvent.disableScrollPropagation(node);
    }
  }, []);
  useEffect(() => {
    if (!info) return;
    const handleClickOutside = (e) => {
      if (infoRef.current && !infoRef.current.contains(e.target)) setInfo(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [info]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);

  // Auto-play functionality
  useEffect(() => {
    let interval;
    if (isPlaying) {
      interval = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % timestamps.length);
      }, 2000); // 2 seconds per frame
    }
    return () => clearInterval(interval);
  }, [isPlaying]);

  const handlePlayPause = () => setIsPlaying(!isPlaying);
  const handleSliderChange = (e) => {
    setCurrentIndex(Number(e.target.value));
    setIsPlaying(false);
  };
  const handlePrevStep = () => {
    setCurrentIndex((prev) => (prev - 1 < 0 ? timestamps.length - 1 : prev - 1));
    setIsPlaying(false);
  };
  const handleNextStep = () => {
    setCurrentIndex((prev) => (prev + 1 >= timestamps.length ? 0 : prev + 1));
    setIsPlaying(false);
  };
  const handleFirst = () => {
    setCurrentIndex(0);
    setIsPlaying(false);
  };
  const handleLast = () => {
    setCurrentIndex(timestamps.length - 1);
    setIsPlaying(false);
  };

  const currentTimestamp = timestamps[currentIndex];
  const formattedDate = currentTimestamp
    .toISOString()
    .replace("T", " ")
    .substring(8, 16)
    .replace(" ", " MAY ")
    .toUpperCase() + " UTC";

  return (
    <div className="relative">
      <MapContainer
        center={[INITIAL_VIEW_STATE.latitude, INITIAL_VIEW_STATE.longitude]}
        zoom={8}
        style={{ width: "100%", height: "82.7vh" }}
      >
        <MapHomeControl />
        <LayersControl position="topright">
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='© <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          />
          <LayersControl.BaseLayer checked name="OpenStreetMap" />

          {/* Boundary Layers */}
          <LayersControl.Overlay checked name="country">
            <BoundaryLayer
              url="/DATA/OSMbased_adm0_boundary.json"
              layerName="country"
            />
          </LayersControl.Overlay>
          <LayersControl.Overlay name="Municipality">
            <BoundaryLayer
              url="/DATA/OSMbased_adm1_boundary.json"
              layerName="municipality"
            />
          </LayersControl.Overlay>
          <LayersControl.Overlay name="Post Admin">
            <BoundaryLayer
              url="/DATA/OSMbased_adm2_boundary.json"
              layerName="submunicipality"
            />
          </LayersControl.Overlay>
          <LayersControl.Overlay name="Suco">
            <BoundaryLayer
              url="/DATA/OSMbased_adm3_boundary.json"
              layerName="suco"
            />
          </LayersControl.Overlay>
        </LayersControl>

        {info && (
          <div
            ref={infoPanelRef}
            style={{
                position: "absolute",
                bottom: "70px",
                left: "12px",
                fontSize: "12px",
                zIndex: 1000,
                padding: "10px 14px",
                borderRadius: "10px",
                background: "rgba(255, 255, 255, 0.9)",
                backdropFilter: "blur(10px) brightness(1.1)",
                WebkitBackdropFilter: "blur(10px) brightness(1.1)",
                border: "1px solid rgba(0, 0, 0, 0.08)",
                boxShadow: "0 4px 16px rgba(0, 0, 0, 0.15), inset 0 1px 2px rgba(255, 255, 255, 0.5)",
                color: "#333333",
                fontWeight: "500",
                maxWidth: "320px",
                lineHeight: "1.4",
              }}
          >
            x-day temperature forecast at x-hour intervals.
          </div>
        )}
        <InfoButton setInfo={setInfo} />

        {/* Bottom Control Bar */}
        <div
          style={{
            position: "absolute",
            bottom: "0",
            left: "0",
            width: "100%",
            background: "white",
            color: "black",
            display: "flex",
            alignItems: "center",
            padding: "5px",
            zIndex: 1000,
            fontFamily: "Arial, sans-serif",
            fontSize: "14px",
          }}
        >
          {/* Play/Pause Button */}
          <button
            onClick={handlePlayPause}
            style={{
              backgroundColor: "#1E90FF",
              border: "none",
              borderRadius: "50%",
              width: "30px",
              height: "30px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "10px",
              cursor: "pointer",
            }}
          >
            {isPlaying ? <FaPause size={14} color="white" /> : <FaPlay size={14} color="white" />}
          </button>

          {/* Navigation Arrows */}
          <button
            onClick={handleFirst}
            style={{
              backgroundColor: "transparent",
              border: "1px solid #666",
              borderRadius: "4px",
              padding: "5px",
              marginRight: "5px",
              cursor: "pointer",
            }}
          >
            <FaAngleDoubleLeft size={14} color="black" />
          </button>
          <button
            onClick={handlePrevStep}
            style={{
              backgroundColor: "transparent",
              border: "1px solid #666",
              borderRadius: "4px",
              padding: "5px",
              marginRight: "10px",
              cursor: "pointer",
            }}
          >
            <FaAngleLeft size={14} color="black" />
          </button>

          {/* Timestamp Display */}
          <span
            style={{
              marginRight: "10px",
              backgroundColor: "white",
              padding: "2px 5px",
            }}
          >
            {formattedDate}
          </span>

          {/* Navigation Arrows (Right) */}
          <button
            onClick={handleNextStep}
            style={{
              backgroundColor: "#fff",
              border: "1px solid #666",
              borderRadius: "4px",
              padding: "5px",
              marginRight: "5px",
              cursor: "pointer",
            }}
          >
            <FaAngleRight size={14} color="black" />
          </button>
          <button
            onClick={handleLast}
            style={{
              backgroundColor: "#fff",
              border: "1px solid #666",
              borderRadius: "4px",
              padding: "5px",
              marginRight: "10px",
              cursor: "pointer",
            }}
          >
            <FaAngleDoubleRight size={14} color="black" />
          </button>

          {/* Slider */}
          <div style={{ flex: 1, position: "relative" }}>
            <input
              type="range"
              min="0"
              max={timestamps.length - 1}
              value={currentIndex}
              onChange={handleSliderChange}
              style={{
                width: "100%",
                background: `linear-gradient(to right, #1E90FF 0%, #1E90FF ${
                  (currentIndex / (timestamps.length - 1)) * 100
                }%, #4A5A6A ${(currentIndex / (timestamps.length - 1)) * 100}%, #4A5A6A 100%)`,
                height: "8px",
                borderRadius: "4px",
                appearance: "none",
                outline: "none",
                cursor: "pointer",
              }}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "12px",
                marginTop: "5px",
                color: "black",
              }}
            >
              <span>{START_DATE.toISOString().substring(8, 10)} MAY 00:00 UTC</span>
              <span>{END_DATE.toISOString().substring(8, 10)} MAY 00:00 UTC</span>
            </div>
          </div>

          {/* Gradient Legend */}
          <div
            style={{
              width: "20%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "0 10px",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "10px",
                background: "linear-gradient(to right, rgb(4, 255, 0), #FFFF00, #FFA500, #FF0000)",
                marginRight: "10px",
              }}
            />
          </div>
        </div>
      </MapContainer>
    </div>
  );
};

export default Fireforecast;